import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel'
import { EditorModule } from 'primeng/editor'
import { DialogModule } from 'primeng/dialog'
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { StepsModule } from 'primeng/steps';
import { FieldsetModule } from 'primeng/fieldset';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DatePickerModule } from 'primeng/datepicker';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChartModule } from 'primeng/chart';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MenubarModule } from 'primeng/menubar';
import { TabMenuModule } from 'primeng/tabmenu';
import { RatingModule } from 'primeng/rating';
import { TabViewModule } from 'primeng/tabview';
import { InputSwitchModule } from 'primeng/inputswitch';
import {  } from 'primeng/';
import { RadioButtonModule } from 'primeng/radiobutton';


@NgModule({
  exports: [
    PanelModule,
    InputTextModule,
    EditorModule,
    DialogModule,
    ButtonModule,
    MultiSelectModule,
    FieldsetModule,
    OverlayPanelModule,
    DatePickerModule,
    FileUploadModule,
    ConfirmDialogModule,
    ToastModule,
    TableModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    ChartModule,
    PanelMenuModule,
    MenubarModule,
    TabMenuModule,
    DialogModule,
    DropdownModule,
    RatingModule,
    CheckboxModule,
    SelectButtonModule,
    StepsModule,
    TabViewModule,
    InputSwitchModule,
    RadioButtonModule
  ]
})
export class PrimengModule { }
